import $ from 'jquery';
import { isPresent } from 'utils/isPresent';
import React, { useEffect, memo } from 'react'
import { compose } from 'redux'
import ui from 'redux-ui'
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider'
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles'
import CircularProgress from 'housecall-ui/dist/DesignSystem/Feedback/Progress/CircularProgress'
import TasksBar from './TasksBar.jsx'
import UndoSnackbar from './UndoSnackbar.jsx'

const styles = {
  root: {
    height: '100%',
  },
  iframe: {
    border: 'none',
    width: 400,
    height: '100%',
  },
  spinnerContainer: {
    textAlign: 'center',
    position: 'relative',
    top: 'calc(50% - 30px)',
  },
}

const TasksBootstrap = ({
  classes,
  updateUI,
  toggleTasksDrawer,
  closeTasksDrawer,
  ui: { foundation, spinner },
}) => {
  const handleIframeMessages = event => {
    if (foundation) {
      if (event.data === 'requestDrawerClose') {
        closeTasksDrawer()
      } else if (event.data === 'requestFeedbackDialogOpen') {
        updateUI('feedbackDialogOpen', true)
      }
    }
  }

  useEffect(() => {
    window.addEventListener('message', handleIframeMessages)
    return window.removeEventListener('message', handleIframeMessages)
  }, [])

  const taskList = () => {
    if (foundation) {
      return (
        <iframe
          src="/pro/tasks"
          className={classes.iframe}
          style={{ display: spinner ? 'none' : 'block' }}
          onLoad={() => {
            updateUI('spinner', false)
          }}
        />
      )
    } else {
      return <TasksBar toggleTasksDrawer={toggleTasksDrawer} />
    }
  }

  let renderSpinner = null

  if (foundation && spinner) {
    renderSpinner = (
      <div className={classes.spinnerContainer}>
        <CircularProgress size={60} />
      </div>
    )
  }

  return (
    <div className={classes.root}>
      {renderSpinner}
      {taskList()}
      <UndoSnackbar />
    </div>
  )
}

const uiState = {
  state: {
    feedbackDialogOpen: false,
    foundation: isPresent($(document.body).data('foundation')),
    spinner: true,
  },
}

export default compose(ui(uiState), withStyles(styles), memo)(TasksBootstrap)
